import { render, staticRenderFns } from "./ClientExpandedContent.vue?vue&type=template&id=75190f8c&scoped=true&"
import script from "./ClientExpandedContent.vue?vue&type=script&lang=js&"
export * from "./ClientExpandedContent.vue?vue&type=script&lang=js&"
import style0 from "./ClientExpandedContent.vue?vue&type=style&index=0&id=75190f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75190f8c",
  null
  
)

export default component.exports